<template>
  <div id="q-app">
    <router-view />
  </div>
</template>

<script>
import lodash from 'lodash'
import Vue from 'vue'
import currentUser from './components/Global/currentUser'
import placesAutocomplete from './components/Shared/googlePlacesAutocomplete.js'
import moment from 'moment'
Vue.mixin(currentUser)
Vue.config.performance = true
export default {
  name: 'App',
  mixins: [ currentUser ],
  components: {
  },
  directives: {
    placesAutocomplete
  },
  created () {
    this.$store.dispatch('loadLookups')
    window._ = lodash // Hey sometimes we've got to pollute globals ¯\_(ツ)_/¯
    window.moment = moment
  }
}
</script>

<style>
</style>
